import { createStore } from 'redux'
import { customerQueryReducer } from './reducer'
const store = createStore(customerQueryReducer)
export default store
